const _import = require('./_import_' + process.env.NODE_ENV);

export default [
  {
    path: '/manage',
    name: 'Manage',
    component: _import('manage/index'),
    children: [
      {
        // 企业中心
        path: 'enterprise-center',
        name: 'EnterpriseCenter',
        component: _import('manage/enterprise-center/index')
      },
      {
        // 账号设置
        path: 'enterprise-config',
        name: 'EnterpriseConfig',
        component: _import('manage/enterprise-config')
      },
      {
        // 公司信息
        path: 'enterprise-info',
        name: 'EnterpriseInfo',
        component: _import('manage/enterprise-info/index')
      },
      {
        // 订单管理
        path: 'enterprise-order',
        name: 'EnterpriseOrder',
        component: _import('manage/enterprise-order')
      },
      {
        // 我的招聘
        path: 'enterprise-recruit',
        name: 'EnterpriseRecruit',
        component: () => import('#/manage/enterprise-recruit/')
      },
      {
        // 我的招聘 -- 发布职位
        path: 'enterprise-publish-job',
        name: 'EnterprisePublishJob',
        component: _import('manage/enterprise-publish-job')
      },
      {
        // 简历库
        path: 'enterprise-resume',
        name: 'EnterpriseResume',
        component: _import('manage/enterprise-resume')
      },
      {
        // 注册
        path: 'enterprise-register',
        name: 'EnterpriseRegister',
        component: _import('manage/enterprise-register')
      },
      {
        // 面试邀请
        path: 'enterprise-interview',
        name: 'EnterpriseInterview',
        component: _import('manage/enterprise-interview/index')
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/manage.router.js